import React from "react";
import { DEVICE_CATEGORIES } from "../lib/content";

export default function SmartScaleMarquee() {
  const items = [...DEVICE_CATEGORIES, ...DEVICE_CATEGORIES];
  return (
    <div className="marquee-track relative w-full overflow-hidden" data-testid="device-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#050505] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#050505] to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-14 py-2">
        {items.map((name, i) => (
          <span
            key={name + i}
            className="whitespace-nowrap font-heading text-2xl font-semibold tracking-tight text-zinc-600 opacity-60 transition-all duration-300 hover:text-white hover:opacity-100 md:text-3xl"
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}
